import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EVMProvider from './contexts/EVMProvider';
import HomePage from './components/HomePage';
import ConnectPage from './components/ConnectPage';

function App() {
  return (
    <EVMProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/connect" element={<ConnectPage />} />
        </Routes>
      </Router>
    </EVMProvider>
  );
}

export default App;